import { isLoggedIn } from '@/utils/auth'
import { handleWeChatGuardAuth } from '@/utils/wechatSilentAuth'

const whiteList = [
  '/login',
  '/register',
  '/payment/unified/pay',
  '/payment/qrcode/innercode',
  '/payment/qrcode/lanecode',
  '/payment/qrcode/rs-record',
  '/h5/rsparking-record',
  '/h5/rsparking-merge',
  '/h5/rsparking-more-arrears',
  '/payment/confirm',
  '/payment/parking-details',
  '/payment/sub-orders',
  '/payment/success',
  '/parking/monthly-card/quick-renewal',
  '/redemption',
  '/transfer'
]

export { isLoggedIn as checkAuth }

/**
 * Payment scan may land on /?r=<encoded /h5/rsparking-record?recordId=...&source=rsparking>.
 * Consume r once so recordId/source are not lost on Home.
 */
function resolveREntryTarget(raw) {
  if (raw == null || raw === '') return null
  let target = Array.isArray(raw) ? raw[0] : String(raw)
  try {
    target = decodeURIComponent(target)
  } catch (e) {
    /* keep raw */
  }
  if (target.includes('%')) {
    try {
      target = decodeURIComponent(target)
    } catch (e) {
      /* keep */
    }
  }
  if (!target.startsWith('/h5/rsparking-record') && !target.startsWith('/h5/rsparking-merge')) {
    return null
  }
  if (target.includes('..')) return null
  const q = target.indexOf('?')
  if (q === -1) {
    return { path: target, query: {} }
  }
  const path = target.slice(0, q)
  const search = target.slice(q + 1)
  const query = {}
  try {
    new URLSearchParams(search).forEach((v, k) => {
      query[k] = v
    })
  } catch (e) {
    return { path, query: {} }
  }
  return { path, query }
}

export const setupGuards = (router) => {
  router.beforeEach(async (to, from, next) => {
    if (to.path === '/' && typeof window !== 'undefined' && window.location.hash) {
      const hash = window.location.hash
      if (hash.startsWith('#/')) {
        const fullPath = hash.slice(1)
        next(fullPath)
        return
      }
    }

    if (to.path === '/' && to.query && to.query.r) {
      const entry = resolveREntryTarget(to.query.r)
      if (entry) {
        next({ path: entry.path, query: entry.query, replace: true })
        return
      }
    }

    const isInWhiteList = whiteList.some(path => {
      const basePath = path.replace(/\/\*?$/, '')
      return to.path.startsWith(basePath)
    })

    const requiresNoAuth = to.matched.some(record => record.meta.noAuth)

    if (isInWhiteList || requiresNoAuth) {
      next()
      return
    }

    if (isLoggedIn()) {
      next()
      return
    }

    const wxResult = await handleWeChatGuardAuth(to.fullPath)
    if (wxResult === 'logged_in') {
      next({ ...to, replace: true })
      return
    }
    if (wxResult === 'oauth_redirect') {
      return
    }

    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  })
}
